<div class="box row pt-2 pb-2">
    <div *ngFor="let item of data" class="col-sm-4 col-6 text-center item">
        <img src="{{item.img}}" class="img-child" />
        <div>{{item.percent}}</div>
    </div>
</div>